import { faFolder, faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ButtonLink from '../../../components/ButtonLink';
import Divider from '../../../components/Divider';
import Input from '../../../components/Input';
import CaseType from '../../../types/CaseType';
import styles from './style.module.scss';

interface Props {
    userCasesList: CaseType[];
}

function UserCases(props: Props) {
    const { userCasesList } = props;

    const [userCases, setUserCases] = useState<CaseType[]>([]);

    useEffect(() => {
        setUserCases(userCasesList);
    }, [userCasesList, setUserCases]);

    // const [typeAction, setTypeAction] = useState<
    //     'new_file' | 'new_case' | 'view_case' | 'view_search' | null
    // >(null);

    // useEffect(() => {
    //     setCases(data);
    //     if (caseId) {
    //         setTypeAction('view_case');
    //     }
    // }, [data, setCases, caseId]);

    // const handleClickNewCase = () => {
    //     setTypeAction('new_case');
    // };

    // const defaultToolbar: NavDataInterface[] = [
    //     {
    //         id: 'toolbarBtn0',
    //         icon: 'fa-folder',
    //         label: 'Nouveau dossier',
    //         onClick: handleClickNewCase,
    //     },
    // ];

    // const navData: NavDataInterface[] = cases.map(
    //     (userCase): NavDataInterface => {
    //         return {
    //             id: userCase.id,
    //             label: userCase.caseName || userCase.caseRef,
    //             subLabel: userCase.user,
    //             date: new Date(),
    //             link: '?id=' + userCase.id,
    //             variant: 'secondaryLight',
    //             icon: 'fa-folder',
    //             iconColor: '#ffbc20',
    //         };
    //     }
    // );

    // const [toolbar, setToolbar] = useState<NavDataInterface[]>();

    // const viewObject = {
    //     new_file: {
    //         view: (
    //             <CaseTextEditor
    //                 setToolbar={setToolbar}
    //                 setTypeAction={setTypeAction}
    //             />
    //         ),
    //     },
    //     new_case: {
    //         view: (
    //             <CaseForm
    //                 setToolbar={setToolbar}
    //                 setTypeAction={setTypeAction}
    //                 request={formRequest}
    //             />
    //         ),
    //     },
    //     view_case: {
    //         view: (
    //             <CaseDetails
    //                 setToolbar={setToolbar}
    //                 setTypeAction={setTypeAction}
    //                 request={detailRequest}
    //                 caseId={caseId}
    //             />
    //         ),
    //     },
    //     view_search: {
    //         view: (
    //             <SearchForCase
    //                 setToolbar={setToolbar}
    //                 setTypeAction={setTypeAction}
    //             />
    //         ),
    //     },
    // };

    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        const searchTerm = e.target.value.toLowerCase();

        if (userCasesList) {
            if (searchTerm.length > 0) {
                const filteredCases =
                    userCasesList?.filter(
                        (caseItem: CaseType) =>
                            caseItem.caseName
                                ?.toLowerCase()
                                .includes(searchTerm) ||
                            caseItem.caseRef
                                ?.toLowerCase()
                                .includes(searchTerm) ||
                            caseItem.user?.toLowerCase().includes(searchTerm)
                    ) || [];
                setUserCases(filteredCases);
            } else {
                setUserCases(userCasesList);
            }
        }
    };

    return (
        <div className={styles.container}>
            <h1 className={styles.title}>
                <span className={styles.headerIcon}>
                    <FontAwesomeIcon icon={faFolder} />
                </span>
                Mes dossiers
            </h1>
            <Divider marginBottom="20px" />
            <div className={styles.search}>
                <Input
                    type="text"
                    placeholder="Dossier, client, référence..."
                    onChange={handleSearch}
                    icon={faSearch}
                />
            </div>
            <div className={styles.userCasesTable}>
                <table>
                    <thead>
                        <tr>
                            <th scope="col"></th>
                            <th scope="col">Dossier</th>
                            <th scope="col">Type</th>
                            <th scope="col">Date de création</th>
                            <th scope="col">status</th>
                            {/* <th scope="col">nombre d'heure travaillée</th> */}
                            {/* <th scope="col">Dernière ouverture</th> */}
                            <th scope="col">Avocat</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody className={styles.events}>
                        {userCases?.map((userCase: CaseType) => (
                            <tr className={styles.event} key={userCase.id}>
                                <td className={styles.iconCol}>
                                    <FontAwesomeIcon icon={faFolder} />
                                </td>
                                <td>{userCase.caseName || userCase.caseRef}</td>
                                <td>{userCase.speciality}</td>
                                <td>
                                    {userCase.creationDate?.toLocaleDateString()}
                                </td>
                                <td>{userCase.status}</td>
                                {/* <td>{userCase.timeSpend}</td> */}
                                <td>{userCase.lawyer}</td>
                                <td>
                                    <ButtonLink link={userCase.id}>
                                        Ouvrir
                                    </ButtonLink>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className={styles.userCases}>
                {userCases?.map((userCase: CaseType) => (
                    <Link
                        key={userCase.id}
                        className={styles.userCase}
                        to={`${userCase.id}`}
                    >
                        <FontAwesomeIcon
                            icon={faFolder}
                            className={styles.icon}
                        />
                        <div className={styles.details}>
                            <span className={styles.name}>
                                {userCase.firstName} {userCase.lastName}
                            </span>
                            <span>{userCase.caseName || userCase.caseRef}</span>
                        </div>
                    </Link>
                ))}
            </div>

            {/* <SideNav
                selected={caseId || ''}
                navData={navData}
                growing={caseId.length > 0}
                hasSearchBar={true}
                searchBarLabel="Dossiers :"
                reduceIcon={faFolder}
            />
            <div className={styles.body}>
                <Toolbar
                    toolbarData={caseId.length > 0 ? toolbar : defaultToolbar}
                    isSticky={caseId.length > 0}
                />
                {typeAction && viewObject[typeAction].view}
            </div> */}
        </div>
    );
}

export default UserCases;
